"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackingProps = exports.SocialLinkProps = exports.SearchEngineOptimisationProps = exports.LayoutProps = exports.LayoutMainProps = exports.LayoutHeaderProps = exports.LayoutFooterProps = exports.LayoutAsideProps = exports.FooterSectionProps = exports.BrandDefinitionProps = exports.BrandConfigPropTypes = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var BrandDefinitionProps = exports.BrandDefinitionProps = _propTypes["default"].shape({
  key: _propTypes["default"].string,
  products: _propTypes["default"].string,
  supportPhoneNumber: _propTypes["default"].string,
  title: _propTypes["default"].string,
  homeUrl: _propTypes["default"].string,
  cssUrls: _propTypes["default"].arrayOf(_propTypes["default"].string),
  logos: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    key: _propTypes["default"].string,
    imageUrl: _propTypes["default"].string,
    redirectUrl: _propTypes["default"].string,
    imageTitle: _propTypes["default"].string,
    imageTitleDescription: _propTypes["default"].string
  })),
  partner: _propTypes["default"].string,
  broker: _propTypes["default"].string,
  favIconUrl: _propTypes["default"].string,
  appIconUrl: _propTypes["default"].string
});
var SearchEngineOptimisationProps = exports.SearchEngineOptimisationProps = _propTypes["default"].shape({
  title: _propTypes["default"].string,
  description: _propTypes["default"].string
});
var TrackingProps = exports.TrackingProps = _propTypes["default"].shape({
  provider: _propTypes["default"].string,
  key: _propTypes["default"].string,
  keyValue: _propTypes["default"].string
});
var SocialLinkProps = exports.SocialLinkProps = {
  icon: _propTypes["default"].string,
  label: _propTypes["default"].string,
  url: _propTypes["default"].string,
  href: _propTypes["default"].string,
  svg: _propTypes["default"].element
};
var FooterSectionProps = exports.FooterSectionProps = _propTypes["default"].shape({
  heading: _propTypes["default"].string,
  content: _propTypes["default"].element,
  links: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    url: _propTypes["default"].string
  }))
});
var LayoutHeaderProps = exports.LayoutHeaderProps = {
  logoImageUrl: _propTypes["default"].string,
  logoHoverText: _propTypes["default"].string,
  logoRedirectUrl: _propTypes["default"].string,
  pageTitleText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  customContent: _propTypes["default"].element,
  customCssClass: _propTypes["default"].string,
  headerShouldPin: _propTypes["default"].bool,
  contactDetails: _propTypes["default"].element
};
var LayoutMainProps = exports.LayoutMainProps = {
  heading: _propTypes["default"].shape({
    headingText: _propTypes["default"].string,
    mandatoryText: _propTypes["default"].string,
    customCssClass: _propTypes["default"].string
  }),
  customContentTop: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].string]),
  customContentBottom: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].string])
};
var LayoutFooterProps = exports.LayoutFooterProps = {
  customContent: _propTypes["default"].element,
  customCssClass: _propTypes["default"].string,
  socialLinks: _propTypes["default"].arrayOf(_propTypes["default"].shape(SocialLinkProps)),
  copyright: _propTypes["default"].element,
  customDisclosure: _propTypes["default"].element,
  footerSections: _propTypes["default"].arrayOf(FooterSectionProps)
};
var LayoutAsideProps = exports.LayoutAsideProps = {
  heading: _propTypes["default"].shape({
    headingText: _propTypes["default"].string
  })
};
var LayoutProps = exports.LayoutProps = _propTypes["default"].shape({
  bodyCssClass: _propTypes["default"].string,
  header: _propTypes["default"].shape(LayoutHeaderProps),
  main: _propTypes["default"].shape(LayoutMainProps),
  footer: _propTypes["default"].shape(LayoutFooterProps),
  aside: _propTypes["default"].shape(LayoutAsideProps)
});
var BrandConfigPropTypes = exports.BrandConfigPropTypes = _propTypes["default"].shape({
  brand: BrandDefinitionProps,
  seo: SearchEngineOptimisationProps,
  tracking: TrackingProps,
  layout: LayoutProps
});